// extracted by mini-css-extract-plugin
module.exports = {"ProfileContainer":"ProfilePict_ProfileContainer__2LtA7","Profile":"ProfilePict_Profile__6eEPP","Profile_square":"ProfilePict_Profile_square__1c__X"};